import get from "lodash/get";

export const getNoteToContractorFetching = state => get(state, "noteToContractor.isFetching");
export const getNoteToContractorFetchSuccess = state => get(state, "noteToContractor.fetchSuccess");
export const getNoteToContractorFetchError = state => get(state, "noteToContractor.hasError");

export const getLocalNoteToContractor = state => get(state, "noteToContractor.localNote");
